import { useSelector } from 'react-redux';
import { RootState } from 'store/types';

export const useLoggedAs = () => {
  const loggedAs = useSelector((state: RootState) => state.auth.loggedAs);
  return loggedAs;
};
